module.exports = __webpack_public_path__ + "img/solution--early-mobilization.07d54d10.jpg";